import React from 'react'
import './edusera.css'
import {BiSolidRightArrow} from 'react-icons/bi'
import Nav from '../nav_home/nav_home'
const Edusera = () => {
  return (
    <section id='edusera'>
        <h2>Edusera</h2>
        <h5>Problem Setter Intern | 08/2021 - 09/2021</h5>
        <div className='responsibilities'>
            <h3>Responsibilities and Deliverables</h3><br/>
            <p><BiSolidRightArrow className='arrow'/> &nbsp;Developed a comprehensive library of C language programming questions, covering a wide range of topics and difficulty
levels<br/><br/>
<BiSolidRightArrow className='arrow'/> &nbsp;Created solutions and test cases to accompany each question, ensuring accuracy and effectiveness in assessing
students' understanding<br/><br/>
<BiSolidRightArrow className='arrow'/> &nbsp;Collaborated with a team of subject matter experts to review and refine the content, ensuring it aligned with the learning
objectives and curriculum requirements<br/><br/>
<BiSolidRightArrow className='arrow'/> &nbsp;Collaborated with the technical team to integrate the question bank into the company's server, ensuring smooth access
and usability for users<br/><br/>
<BiSolidRightArrow className='arrow'/> &nbsp;Maintained an up-to-date knowledge of C language programming concepts and best practices to ensure the relevance and
quality of the content<br/><br/>
<BiSolidRightArrow className='arrow'/> &nbsp;Utilized strong C language programming skills to write clear, concise, and accurate code examples for instructional
purposes</p>
        </div>
        <div className="skills">
            <h3>Skills Used</h3><br/>
            <p>
            <BiSolidRightArrow className='arrow'/> &nbsp;Proficient in C language programming, demonstrated through the creation of accurate and efficient code examples<br/><br/>
            <BiSolidRightArrow className='arrow'/> &nbsp;Strong problem-solving skills, enabling the development of challenging and thought-provoking programming questions<br/><br/>
            <BiSolidRightArrow className='arrow'/> &nbsp;Attention to detail, ensuring the accuracy and quality of solutions and test cases<br/><br/>
            <BiSolidRightArrow className='arrow'/> &nbsp;Collaboration and communication skills, effectively working with subject matter experts and technical teams to deliver high-quality content<br/><br/>
            <BiSolidRightArrow className='arrow'/> &nbsp;Ability to adapt to evolving educational requirements and incorporate feedback into content development

            </p>
        </div>
        <Nav/>
    </section>
  )
}

export default Edusera